const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * @param {unknown} value - version_id_ref from API; may be string UUID, number, or nested object
 * @returns {string|null} single UUID string, or null if not usable
 */
export function normalizeVersionIdRef(value) {
  if (value == null) return null;
  if (typeof value === "string") {
    const t = value.trim();
    if (!t || t === "[object Object]") return null;
    return UUID_RE.test(t) ? t : null;
  }
  if (typeof value === "number" && Number.isFinite(value)) {
    return null;
  }
  if (typeof value === "object" && !Array.isArray(value)) {
    const o = value;
    const fromObj =
      o.version_id_ref ??
      o.version_id ??
      o.id ??
      o.versionId ??
      o.versionID;
    if (fromObj != null && typeof fromObj !== "object") {
      return normalizeVersionIdRef(String(fromObj));
    }
  }
  return null;
}

export function uniqueVersionIdRefs(list) {
  const out = [];
  const seen = new Set();
  for (const v of list || []) {
    const n = normalizeVersionIdRef(v);
    if (n && !seen.has(n)) {
      seen.add(n);
      out.push(n);
    }
  }
  return out;
}
